export const defaultChartMenuItems = [
  'separator',
  'viewFullscreen',
  'printChart',
  'separator',
  'downloadPNG',
  'downloadJPEG',
  'downloadPDF',
  'downloadSVG'
]

export const chartTypes = [
  { id: 'column', type: 'column', name: 'column' },
  { id: 'line', type: 'line', name: 'line' },
  { id: 'bar', type: 'bar', name: 'bar' },
  { id: 'area', type: 'area', name: 'area' },
  { id: 'stackedArea', type: 'area', name: 'stacked area', options: { series: { stacking: 'normal' } } }
]

export const interpolate = ser => {
  const blocks = ser.data
    .reduce((acc, cur, ind, arr) => {
      if (null === cur && null !== arr[ind - 1]) acc.push([ind - 1])
      if (acc.length && null === cur && null !== arr[ind + 1]) acc[acc.length - 1].push(ind + 1)
      return acc
    }, [])
    .filter(v => 2 === v.length)
  const data = ser.data.slice()
  for (const [from, to] of blocks) {
    for (let i = from + 1; i <= to - 1; i++) {
      const value = ser.data[from] + ((ser.data[to] - ser.data[from]) * (i - from)) / (to - from)
      data[i] = { y: value, marker: { symbol: 'circle', radius: 1 } }
    }
  }
  ser.data = data
  return ser
}
